/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useEffect, useState } from 'react';
import "../Login/login.scss";
import "./signup.scss";
import { BallBeat } from '../../Loader/loader';
import Snackbar from '@mui/material/Snackbar';
import { userSignup, verifyOtp } from '../../Redux/ActionCreators/authAction';
import { clearErrors } from '../../Redux/ActionCreators/errorAction';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Alert } from '@mui/material';
import { freshsales_new_contact } from '../../utils/freshSales';
import { useTranslation } from 'react-i18next';

const COMPANY_LOGOS = [
    { src: '/images/company-logo1.png', alt: 'Hungry Hub' },
    { src: '/images/company-logo2.png', alt: 'SECROO' },
    { src: '/images/company-logo3.png', alt: 'abc' },
    { src: '/images/company-logo4.png', alt: 'RuralEdge' },
    { src: '/images/company-logo5.png', alt: 'MUDON' },
    { src: '/images/company-logo1.png', alt: 'Hungry Hub' },
    { src: '/images/company-logo2.png', alt: 'SECROO' },
    { src: '/images/company-logo3.png', alt: 'abc' },
    { src: '/images/company-logo4.png', alt: 'RuralEdge' },
    { src: '/images/company-logo5.png', alt: 'MUDON' },
];

// Duplicate for seamless infinite scroll
const CAROUSEL_LOGOS = [...COMPANY_LOGOS, ...COMPANY_LOGOS];

function Signup() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [verifyMsg, setVerifyMsg] = useState(false);
    const [showOtpScreen, setShowOtpScreen] = useState(false);
    const [otpValues, setOtpValues] = useState(['', '', '', '', '', '']);
    const [isVerifyLoading, setIsVerifyLoading] = useState(false);
    const [nameError, setNameError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [successEnable, setSuccessEnable] = useState(false);
    const { t } = useTranslation();
    const [successMessageText, setSuccessMessageText] = useState('');
    const [responseStatus, setResponseStatus] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const plan_uuid = queryParams.get("plan_uuid");

    const error = useSelector(state => state.error);

    useEffect(() => {
        if (localStorage.getItem('token')) {
            (window.location.pathname === '/' || window.location.pathname === '/login' || window.location.pathname === '/signup' || window.location.pathname === '/coupon-redeem') && (
                navigate('/jobs/createjob')
            );
        } else {
            window.location.pathname === '/' && navigate('/signup');
        }
    }, []);

    const onNameChange = (e) => { setNameError(''); setName(e.target.value); };
    const onEmailChange = (e) => { setEmailError(''); setEmail(e.target.value); };
    const onChangePassword = (e) => { setPasswordError(''); setPassword(e.target.value); };

    const handleOtpChange = (index, value) => {
        if (!/^[0-9]?$/.test(value)) return;
        const newOtpValues = [...otpValues];
        newOtpValues[index] = value;
        setOtpValues(newOtpValues);
        if (value && index < 5) {
            document.getElementById(`otp-input-${index + 1}`).focus();
        }
    };

    const handleOtpKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !otpValues[index] && index > 0) {
            document.getElementById(`otp-input-${index - 1}`).focus();
        }
    };

    const handleOtpPaste = (e) => {
        e.preventDefault();
        const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
        if (!pasted) return;
        const newOtpValues = [...otpValues];
        pasted.split('').forEach((char, i) => { newOtpValues[i] = char; });
        setOtpValues(newOtpValues);
        const nextIndex = Math.min(pasted.length, 5);
        document.getElementById(`otp-input-${nextIndex}`)?.focus();
    };

    const handleVerifyOtp = async () => {
        const otpString = otpValues.join('');
        if (otpString.length < 6) {
            setSuccessEnable(true);
            setSuccessMessageText("Please enter a valid 6-digit OTP");
            return;
        }
        setIsVerifyLoading(true);
        const obj = { emailId: email, otp: otpString };
        const res = await dispatch(verifyOtp(obj));
        if (res?.type === 'LOGIN_USER') {
            setTimeout(() => {
                const details = JSON.parse(localStorage.getItem("profileDetails") || "{}");
                if (details?.roleId === "1") {
                    navigate('/users');
                } else {
                    navigate('/jobs/createjob');
                }
            }, 1000);
        } else {
            setSuccessEnable(true);
            setSuccessMessageText(error.successMessageText || "Invalid OTP");
        }
        setIsVerifyLoading(false);
    };

    const doSignup = async () => {
        setIsLoading(true);
        setResponseStatus('');
        let emailvalue = email;
        const validemail = /^([\w.-]+)@(\[(\d{1,3}\.){3}|(?!hotmail|gmail|googlemail|yahoo|gmx|ymail|outlook|bluewin|protonmail|t\-online|web\.|online\.|aol\.|live\.)(([a-zA-Z\d-]+\.)+))([a-zA-Z]{2,63}|\d{1,3})(\]?)$/;
        // eslint-disable-next-line no-useless-escape
        let emailrex = /^(([^<>()\[\]\\.,;:\s@"]+(.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (name === '') {
            setNameError(t(`Name can't be blank`));
            setIsLoading(false);
            return false;
        } else if (!emailvalue) {
            setEmailError(t(`Email can't be blank`));
            setIsLoading(false);
            return false;
        } else if (!emailrex.test(String(emailvalue))) {
            setEmailError(t("Email is not valid"));
            setIsLoading(false);
            return false;
        } else if (!validemail.test(String(emailvalue.toLowerCase()))) {
            setEmailError(t("Please enter only work email address"));
            setIsLoading(false);
            return false;
        } else if (password === "") {
            setPasswordError(t('Please enter password'));
            setIsLoading(false);
        } else {
            let signup = plan_uuid ? {
                "name": name, "emailId": email, "password": password, "signupPlanId": plan_uuid
            } : {
                "name": name, "emailId": email, "password": password,
                "tenentTypeEnterprise": true,
                "emailVerificationUrl": window.location.protocol + '//' + window.location.host + "/login/id"
            };
            try {
                const res = await dispatch(userSignup(signup));
                if (res?.type === 'SIGNUP_USER') {
                    await freshsales_new_contact(name, email, 'webfree');
                    setShowOtpScreen(true);
                } else if (res?.payload?.status === 209) {
                    setSuccessEnable(true);
                    setSuccessMessageText("Email already registered.");
                } else if (res?.payload?.msg) {
                    setSuccessEnable(true);
                    setSuccessMessageText("Email already registered.");
                }
            } catch (err) {
                console.error(err);
                setSuccessEnable(true);
                setSuccessMessageText("An error occurred during signup.");
            } finally {
                setIsLoading(false);
            }
        }
    };

    const loginOnKeyDown = async (e) => {
        if (e.key === 'Enter') {
            await doSignup();
        }
    };

    const gotologin = () => { window.location.href = '/login'; };

    const snackClosed = () => {
        dispatch(clearErrors());
        setSuccessEnable(false);
        setSuccessMessageText('');
    };

    return (
        <Fragment>
            {/* ── Snackbars ── */}
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={error.successMessage}
                onClose={snackClosed}
                autoHideDuration={4000}
            >
                <Alert onClose={snackClosed} severity="error" sx={{ width: '100%' }}>
                    {error.successMessageText}
                </Alert>
            </Snackbar>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={error.successEnable}
                onClose={snackClosed}
                autoHideDuration={4000}
            >
                <Alert onClose={snackClosed} severity="success" sx={{ width: '100%' }}>
                    {error.successMessageText}
                </Alert>
            </Snackbar>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={successEnable}
                onClose={snackClosed}
                autoHideDuration={4000}
            >
                <Alert onClose={snackClosed} severity="error" sx={{ width: '100%' }}>
                    {successMessageText}
                </Alert>
            </Snackbar>

            {/* ── Page ── */}
            <div className="signup-page">
                <div className="signup-card-wrapper">
                    <div className="signup-card">

                        {/* ── Left Panel ── */}
                        <div className="signup-left">
                            <div>
                                <div className="signup-left-logo" title="Gappeo" style={{ backgroundImage: `url(${'/images/gappeoai-logo.png'})`, backgroundPosition: 'center center', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', width: '100%', height: 40 }}></div>
                                <h2 className="signup-tagline">Smart AI-Powered Hiring Starts Here</h2>
                            </div>

                            {/* Replace src with the correct image path */}
                            <img src="/images/gappeo-signup-bg.svg" alt="Gappeo AI Hiring" className="signup-hero-img" />

                            {/* Trusted by section */}
                            <div className='trusted-section'>
                                <p style={{ color: '#9CA3AF', fontSize: 12, marginBottom: 10 }}>
                                    Trusted by Global Staffing and Recruitment firms
                                </p>
                                {/* Infinite scrolling logo strip */}
                                <div className="logo-carousel-section">
                                    <div className="logo-carousel-track">
                                        {CAROUSEL_LOGOS.map((logo, i) => (
                                            <img
                                                key={i}
                                                src={logo.src}
                                                alt={logo.alt}
                                                className="carousel-logo"
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>

                        </div>

                        {/* ── Right Panel ── */}
                        <div className="signup-right">

                            {/* Form panel */}
                            <div className={`signup-panel ${showOtpScreen ? 'panel-exit-left' : 'panel-enter'}`}>
                                {!verifyMsg ? (
                                    <div className="signup-right-inner">
                                        <div
                                            className='right-logo'
                                            title="Gappeo"
                                            style={{
                                                backgroundImage: `url(${'/images/gappeoai-logo.png'})`,
                                                backgroundPosition: 'center',
                                                backgroundSize: 'contain',
                                                backgroundRepeat: 'no-repeat',
                                                width: '100%',
                                                height: 36,
                                                marginBottom: 16,
                                            }}
                                        />
                                        <h2>{t('Sign up', { ns: 'profile' })}</h2>

                                        {responseStatus && (
                                            <span style={{ fontWeight: 600, color: 'red', fontSize: 14, display: 'block', marginBottom: 8 }}>
                                                {responseStatus}
                                            </span>
                                        )}
                                        <div className='signup-form'>
                                            <div className="form-group mt-2">
                                                <div className="has-search">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder={t('Name', { ns: 'profile' })}
                                                        value={name}
                                                        onChange={onNameChange}
                                                        onKeyDown={loginOnKeyDown}
                                                    />
                                                </div>
                                                <div className="error">{nameError}</div>
                                            </div>

                                            <div className="form-group mt-2">
                                                <div className="has-search">
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        placeholder='Work email'
                                                        value={email}
                                                        onChange={onEmailChange}
                                                        onKeyDown={loginOnKeyDown}
                                                    />
                                                </div>
                                                <div className="error">{emailError}</div>
                                            </div>

                                            <div className="form-group mt-2">
                                                <div className="has-search">
                                                    <input
                                                        type="password"
                                                        className="form-control"
                                                        placeholder={t('Password', { ns: 'profile' })}
                                                        value={password}
                                                        onChange={onChangePassword}
                                                        onKeyDown={loginOnKeyDown}
                                                    />
                                                </div>
                                                <div className="error">{passwordError}</div>
                                            </div>

                                            <div className="mt-3">
                                                <button
                                                    type="submit"
                                                    onClick={doSignup}
                                                    disabled={isLoading}
                                                    className="login-button"
                                                >
                                                    {isLoading
                                                        ? <BallBeat color={'#fff'} loading={true} />
                                                        : t("SUBMIT")}
                                                </button>
                                            </div>
                                        </div>
                                            <p>Existing user? {" "}
                                                <span className="login-link" onClick={gotologin}>
                                                    Login
                                                </span>
                                            </p>
                                    </div>
                                ) : (
                                    <div className="signup-right-inner">
                                        <h4 style={{ color: '#fff', textAlign: 'center' }}>
                                            {t('Email sent to your registered email. Please verify your email address', { ns: 'profile' })}
                                        </h4>
                                    </div>
                                )}
                            </div>

                            {/* OTP panel */}
                            <div className={`signup-panel ${showOtpScreen ? 'panel-enter' : 'panel-exit-right'}`}>
                                <div className="signup-right-inner text-center">
                                    <div
                                        title="Gappeo"
                                        style={{
                                            backgroundImage: "url('/images/gappeo-signup-bg.svg')",
                                            backgroundPosition: 'center',
                                            backgroundSize: 'contain',
                                            backgroundRepeat: 'no-repeat',
                                            width: '100%',
                                            height: 36,
                                            marginBottom: 16,
                                        }}
                                    />
                                    <h2>{t('Verify OTP', { ns: 'profile' })}</h2>
                                    <p style={{ color: '#9CA3AF', marginBottom: 24 }}>
                                        {t('Please enter the 6-digit OTP sent to your email.', { ns: 'profile' })}
                                    </p>

                                    <div className="otp-boxes d-flex justify-content-center my-3 gap-2">
                                        {otpValues.map((value, index) => (
                                            <input
                                                key={index}
                                                id={`otp-input-${index}`}
                                                type="text"
                                                maxLength="1"
                                                value={value}
                                                onChange={(e) => handleOtpChange(index, e.target.value)}
                                                onKeyDown={(e) => handleOtpKeyDown(index, e)}
                                                onPaste={handleOtpPaste}
                                                className="form-control text-center p-0"
                                            />
                                        ))}
                                    </div>

                                    <button
                                        type="button"
                                        onClick={handleVerifyOtp}
                                        disabled={isVerifyLoading}
                                        className="login-button mt-2"
                                    >
                                        {isVerifyLoading
                                            ? <BallBeat color={'#fff'} loading={true} />
                                            : t('VERIFY OTP', { ns: 'profile' })}
                                    </button>

                                    <div
                                        className="forgot-btn mt-3"
                                        onClick={() => setShowOtpScreen(false)}
                                    >
                                        {t('Back to Sign Up', { ns: 'profile' })}
                                    </div>
                                </div>
                            </div>

                        </div>
                        {/* end right panel */}

                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default Signup;
